import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';
import * as types from './types';
import { ToastState } from '../../types';

type ToastAction = { type: string; payload: ToastState | null };

const initialState: ToastState = {
  isVisible: false,
  message: '',
  type: 'info',
};

const userReducer = (
  state: ToastState ,
  action: ToastAction,
): ToastState => {
  switch (action.type) {
    case types.SHOW_TOAST:
      return {
        ...state,
        ...action.payload,
      };
    case types.HIDE_TOAST: {
      return {
        ...state,
        isVisible: false,
        message: state?.message ?? '',
        type: state?.type ?? 'success',
      };
    }
    default:
      return initialState;
  }
};

type ToastContextType = [ToastState | null, Dispatch<ToastAction>];
export const ToastContext = createContext<ToastContextType>([
  initialState,
  () => initialState,
]);

const ToastProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [toastInfo, dispatchToastInfo] = useReducer(userReducer, initialState);

  return (
    <ToastContext.Provider value={[toastInfo, dispatchToastInfo]}>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastProvider;
